import Home from './home'
import HomeQuery, { HOME_QUERY } from './home.query'

export { HomeQuery, HOME_QUERY }

export default Home
